import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import AmpAccordian from "../common/AmpAccordian/AmpAccordian";
import QuestionIcon from "../common/Icons/QuestionIcon/QuestionIcon";

import "./Faq.css";
import addSuperScript from "../../utils/superscript";

export default function Faq(): JSX.Element {

    const { t } = useTranslation('faq');

    const faqContent = [
        {
            "title": t("faq-accordion.first-title") as string,
            "content": <><p key="0">{t("faq-accordion.first-paragraph-1") as string}</p><p key="1">{t("faq-accordion.first-paragraph-2") as string}</p></>
        },
        {
            "title": t("faq-accordion.second-title") as string,
            "content": <><p key="0">{t("faq-accordion.second-paragraph-1") as string}</p>
            <p key="1">{t("faq-accordion.second-paragraph-2") as string}</p>
            <p key="2">{t("faq-accordion.second-paragraph-3") as string}</p>
            <p key="3">{t("faq-accordion.second-paragraph-4") as string}</p></>
        },
        {
            "title": t("faq-accordion.third-title") as string,
            "content": <><p key="0">{t("faq-accordion.third-paragraph-1") as string}</p><p key="1">{t("faq-accordion.third-paragraph-2") as string}</p></>
        },
        {
            "title": t("faq-accordion.fourth-title") as string,
            "content": <p>{t("faq-accordion.fourth-paragraph-1") as string}</p>
        },
        {
            "title": t("faq-accordion.fifth-title") as string,
            "content": <><p key="0">{t("faq-accordion.fifth-paragraph-1") as string}</p><p key="1">{t("faq-accordion.fifth-paragraph-2") as string}</p></>
        },
        {
            "title": t("faq-accordion.sixth-title") as string,
            "content": <p>{t("faq-accordion.sixth-paragraph-1") as string}</p>
        },
        {
            "title": t("faq-accordion.seventh-title") as string,
            "content": <p>{t("faq-accordion.seventh-paragraph-1") as string} <Link to="/amp/contact-us" target="_blank" rel="noreferrer noopener">{t("faq-accordion.seventh-hyperlink-text")}</Link></p>
        },
        {
            "title": t("faq-accordion.eighth-title") as string,
            "content": <><p key="0">{addSuperScript(t("faq-accordion.eighth-paragraph-1") as string)}</p><p key="1">{t("faq-accordion.eighth-paragraph-2") as string}</p></>
        },
        {
            "title": t("faq-accordion.ninth-title") as string,
            "content": <p>{t("faq-accordion.ninth-paragraph-part-1") as string} {(t("faq-accordion.ninth-paragraph-part-2") as string) !== "" && <i>{t("faq-accordion.ninth-paragraph-part-2") as string}</i>} 
             {t("faq-accordion.ninth-paragraph-part-3") as string} {(t("faq-accordion.ninth-paragraph-part-4") as string) !== "" && <i>{t("faq-accordion.ninth-paragraph-part-4") as string}</i>} {t("faq-accordion.ninth-paragraph-part-5") as string} 
             {(t("faq-accordion.ninth-paragraph-part-6") as string) !== "" && <i>{t("faq-accordion.ninth-paragraph-part-6") as string}</i>} {t("faq-accordion.ninth-paragraph-part-7") as string}</p>
        }
    ];

    const [accordionState, SetAccordionState] = useState(Array(faqContent.length).fill(false));

    const updateAccordionState = (index: number) => {
        const newAccordionState = Array(faqContent.length).fill(false);
        newAccordionState[index] = !accordionState[index];
        SetAccordionState(newAccordionState);
    }

    return (
        <div className="faq-inner-container">
            <div className="faq-image-container">
                <QuestionIcon className="faq-image" />
            </div>
            <div className="faq-answer">
                <div className="faq-answer-content">
                    <div className="faq-answer-content-description">
                        <h2 className="faq-answer-title" id="faq">{t("faq-title") as string}</h2>
                        <p>{t("faq-paragraph-1") as string}</p>
                        <p>{t("faq-paragraph-2") as string}</p>
                    </div>
                    {faqContent.map((faqEntry, i) => (
                        <div key={i} className="faq-accordion" onClick={() => {updateAccordionState(i)}} data-testid={"test-faq-accordion-" + i}>
                            <AmpAccordian title={addSuperScript(faqEntry.title)} content={(faqEntry.content)} isOpen={accordionState[i]} />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}